var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon__list"},_vm._l((_vm.items),function(coupon){return _c('bsi-coupon-list-item',{key:coupon.cartItemId,attrs:{"item":coupon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }